import { useAuth } from '@/auth/AuthContext';

// UI-only gate mirroring the server's granted policies. The backend remains the
// authoritative check (every app-service method is [Authorize]-guarded); this
// only decides what to render.
export function usePermission(): (permission?: string | null) => boolean {
  const { grantedPolicies } = useAuth();
  return (permission?: string | null) => {
    if (!permission) return true;
    return grantedPolicies[permission] === true;
  };
}
